/* eslint-disable func-names */
import React from 'react';
// @ts-ignore
import { withRouter } from 'react-router-dom';
import { Typography, Col, Row, Form, Button, Divider, message, Modal, Table } from 'antd';
import PageTitle from 'shared_components/page_title';
import Message from 'shared_components/message';
import {
	fetchAdditionalFields,
	updateDonor,
	createDonor,
} from 'services/blood_bank/donor_registration';
import HttpCodeMessage from 'shared_components/message_http_status';
import {
	fetchHealthInfoById,
	createHealthInformation,
	updateHealthInformation,
} from 'services/blood_bank/health_info';
import { GLOBAL_TABLE_SIZE, GLOBAL_TABLE_YSCROLL, LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import DynamicInput from './dynamic_input/index';
import DonorRegSteps from '../DonorRegSteps';
import NotifModal from './modal/Modal';

import PersonalInfoDetails from './personalInfo';
import { toUpper } from 'lodash';

const { Title } = Typography;

class HealthInformation extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			donorPersonalInfo: {},
			categoryData: {},
			loading: false,
			fields: null,
			hide: false,
			modalVisible: null,
		};

		this.formRef = React.createRef();
		this.bloodTypeRef = React.createRef();
	}


	 createFormInput = record => {
		if (record) {
			console.log('table step 7');
			const initialValue = record.releasedResultMultiple
				? record.releasedResultMultiple
				: record.releasedResult;

			return (
				<Form.Item name={record.fieldName} initialValue={initialValue}>
					<DynamicInput
						hideElements={false}
						type={record.examItemTypeCode}
						// isLock={record.examRequestItemLock === 1 || resultStatus === 'Approve'}
						itemOptions={record.examItemOptions}
						maxLength={record.maxLength}
						// onChange={handleChangeResult}
					/>
				</Form.Item>
			);
		}
	};

	async componentDidMount() {
		const state = JSON.parse(sessionStorage.getItem('DNR_PERSONAL_INFO')); // this state from fillup form

		// const { health_info_id, block, blood_type } = this.props.location.state;
		await this.getCategoryData();
		this.setState({ hide: false, modalVisible: state.block || null, donorPersonalInfo: state });

		// if(health_info_id)
		//   await this.fetchHealthInfo(health_info_id);

		console.log('personal-info', state);
		// console.log('props health info page', this.props.location.state);
	}

	onFinish = async formFields => {
		const { donorPersonalInfo } = this.state;

		let createdUserResponse = {};
		let updateUserResponse = {};

		// use to update or create donor personal info in database //istian - 05-26-23
		if (donorPersonalInfo.donor_id) {
			if (donorPersonalInfo.isUnchanged === true) {
				console.log('UNCHANGE');
			} else {
				console.log('UPDATE');
				updateUserResponse = await updateDonor(donorPersonalInfo);
				if (createdUserResponse.status === 201) {
					const httpMessageConfig = {
						message: 'Update successful!',
						status: createdUserResponse.status,
						duration: 1,
					};

					HttpCodeMessage(httpMessageConfig);
				}
			}
		} else {
			if (donorPersonalInfo.label === 'SUBMIT') {
				console.log('SUBMIT');
				createdUserResponse = await createDonor(donorPersonalInfo);
				if (createdUserResponse.status === 201) {
					const httpMessageConfig = {
						message: 'Create Successful!',
						status: createdUserResponse.status,
						duration: 1,
					};

					HttpCodeMessage(httpMessageConfig);
				}
			}
		}

		// const { donor_id } = this.props.location.state;
		const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

		const custom_fields = Object.keys(formFields).map((val, index) => {
			const id = index + 2;
			return {
				field_id: id,
				field_name: val,
				field_value: formFields[val],
			};
		});

		const payload = {
			donor: donorPersonalInfo.donor_id || createdUserResponse.data.donor_id,
			is_extracted: false,
			is_screened: false,
			custom_fields: custom_fields,
		};

		console.log(payload);

		this.setState({ loading: true });

		// await this.createHealthInfo({ ...payload, created_by: loggedinUser.userID });  // na comment ko muna para d mag run ang creatHealthInfo

		this.setState({ loading: false });
	};
	

	createHealthInfo = async payload => {
		const { history } = this.props;
		const result = await createHealthInformation(payload);

		// @ts-ignore
		const passedHealthInfo = Object.entries(result.data.messages).length === 0 ? true : false;

		if (passedHealthInfo === true) {
			// @ts-ignore
			if (result.status === 201) {
				Message.success({
					message: 'Health information succesfully submitted!',
					onClose: () => history.push('/bloodbank/donor_registration/step/1'),
				});
			} else Message.error();
		} else {
			// @ts-ignore
			const Messages = Object.values(result.data.messages).map(value => {
				return message.error(value === Array(0) ? null : value);
			});
			this.setState({ hide: true });
		}
	};

	redirectPage = () => {
		const { history } = this.props;
		Message.success({
			message: 'Health information succesfully submitted!',
			setTimeout: 5,
			onClose: () => history.push('/bloodbank/donor_registration/step/1'),
		});
	};

	updateHealthInfo = async payload => {
		const { history } = this.props;
		const result = await updateHealthInformation(payload);

		// @ts-ignore
		if (result.status === 201)
			Message.success({ message: 'Health information succesfully updated!' });
		else Message.error();
	};

	getCategoryData = async () => {
		const additionalFieldsData = await fetchAdditionalFields();

		if (additionalFieldsData.dynamic_fields.length > 0) {
			this.setState({
				fields: additionalFieldsData.dynamic_fields,
			});
		}
	};

	fetchHealthInfo = async id => {
		const healthInfo = await fetchHealthInfoById(id);
		// const { setFieldsValue } = this.formRef.current;

		if (healthInfo.custom_fields) {
			const fieldValue = {};

			healthInfo.custom_fields.forEach(element => {
				fieldValue[element.field_name] = element.field_value;
			});

			// setFieldsValue({ blood_type: fieldValue.blood_type });
		}
	};

	onClickRedirect = () => {
		this.props.history.push('/bloodbank/donor_registration/step/1', { label: 'SUBMIT' });
	};

	render() {
		const { fields, loading, hide, modalVisible, donorPersonalInfo } = this.state;
		// const { health_info_id, blood_type } = this.props.location.state;

		const columns = [
			{
				title: 'EXAM',
				dataIndex: 'examItemName',
				width: 220,
				render: (text, record) => <div style={record.isChild && { marginLeft: 30 }}>{text}</div>,
			},
			{
				title: 'INS. RESULT',
				dataIndex: 'instrumentResult',
				width: 150,
			},
			{
				title: 'RESULT',
				dataIndex: 'releasedResult',
				width: 150,
				render: (text, record) => {
					if (record.releasedResult !== undefined) {
						return this.createFormInput({
							...record,
							fieldName: `${record.sampleSpecimenID}-${record.examItemID}`,
						});
					}
	
					return null;
				},
			},
			{
				title: 'UNIT CODE',
				width: 100,
				render: (text, record) => {
					if (record.unitOfMesureBase && record.examItemUnitCode)
						return `${record.unitOfMesureBase} - ${record.examItemUnitCode}`;
	
					return '';
				},
			},
			{
				title: 'NORMAL VALUES',
				dataIndex: 'displayValue',
				width: 150,
			},
			{
				title: 'STATUS',
				dataIndex: 'flag',
				width: 120,
				render: (text, record) => {
					if (record.flag !== 'NORMAL' && record.flag !== undefined)
						return (
							<div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{`${toUpper(
								record.flag,
							)}`}</div>
						);
	
					return '';
				},
			},
		];

		return (
			<div>
				<PageTitle pageTitle="DONOR REGISTRATION" />
				<DonorRegSteps activeIndex={4} />
				{/* <div className="space-y-md"></div> */}
				<Row justify="center">
					<Col span={20}>
						<h2 className="font-lg font-bolder">HEALTH INFORMATION</h2>
						<Form name="basic" layout="vertical" onFinish={this.onFinish} ref={this.formRef}>
							<Row>
								<Col xs={24} sm={24} md={24} lg={6} xl={6}>
									<PersonalInfoDetails patientInfo={donorPersonalInfo} patientOtherInfo={[]} />
								</Col>
								<Col xs={24} sm={24} md={24} lg={1} xl={1}></Col>
								<Col xs={24} sm={24} md={24} lg={16} xl={16}>
									<Col span={12}>
										<div style={{ marginBottom: '30px' }}>
											<h1
												style={{
													marginBottom: '0',
													fontWeight: 'bold',
													letterSpacing: '1px',
													fontSize: '20px',
													textTransform: 'uppercase',
												}}
											>
												{`${donorPersonalInfo.first_name} ${donorPersonalInfo.middle_name} ${donorPersonalInfo.last_name}`}
											</h1>
											<div style={{ color: '#CCC8C8', letterSpacing: '1px', fontSize: '13px' }}>
												<span>SAMPLE ID: </span>
												<br />
												<span>REQUEST ID: </span>
												<br />
												<span>CURRENT STATUS:</span>
											</div>
										</div>
									</Col>
									<Divider />
									{/* <DynamicFields
										fields={fields}
										// isUpdate={donorPersonalInfo.custom_fields_list.health_info_id !== undefined}
										bloodType={donorPersonalInfo.blood_type}
									/> */}
										<Table
											dataSource={[]}
											columns={columns}
											rowKey={item => item.examItemID}
											scroll={{ x: 800, y: GLOBAL_TABLE_YSCROLL }}
											size={GLOBAL_TABLE_SIZE}
											pagination={false}
											// onRow={record => {
											// 	return {
											// 		onClick: () => {
											// 			setTableRowData(record);
											// 		},
											// 	};
											// }}
										/>
								</Col>
							</Row>
							<div className="space-y-md"></div>
							<Divider style={{ marginTop: 50 }} />
							<div style={{ textAlign: 'right' }}>
								{hide === false ? (
									<Button
										loading={loading}
										type="primary"
										htmlType="submit"
										shape="round"
										style={{ width: 120 }}
									>
										Submit
									</Button>
								) : (
									<></>
								)}
								{hide === true ? (
									<Button
										loading={loading}
										type="primary"
										shape="round"
										style={{ width: 120 }}
										onClick={this.redirectPage}
									>
										Continue
									</Button>
								) : (
									<></>
								)}
							</div>
							<NotifModal isDisplay={modalVisible} isRedirected={this.onClickRedirect} />
						</Form>
					</Col>
				</Row>
			</div>
		);
	}
}

// @ts-ignore
export default withRouter(HealthInformation);
